import { ValueOf } from '../../../../../../shared/type/util.type.ts';
import { Action } from './Action.ts';
import {
  StoresDeliveryCompanies,
  CateLists,
  StoreEcommerceInfos,
  CateItems,
} from '@services/database/mco/schema/public';
import { GoodsTypeId } from '@services/MarppleShop/features/Product/type';
import { StoreProduct } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/StoreProduct/StoreProduct.ts';
import { MembershipSettingSectionData } from '@modules/Creator/Setting/S/MembershipSettingForm/MembershipSettingSection.ts';
import { MpsCategory } from '../../../../../../shared/mps-shared/domain/category/accessor.ts';

export const MODE = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  EDIT_TPL: 'EDIT_TPL',
  EDIT_TPL_INTL: 'EDIT_TPL_INTL',
} as const;
export type MODE = ValueOf<typeof MODE>;

interface ExtendedCateLists extends CateLists {
  _: {
    cate_items: Array<CateItems>;
  };
}

export interface CreatorProductDefaultData {
  action: Action;
  is_force_out_of_stock: boolean;
  cate_lists: Array<ExtendedCateLists>;
  cate_items?: Array<CateItems>;
  store_ecommerce_info: Array<StoreEcommerceInfos>;
  stores_delivery_companies: Array<Partial<StoresDeliveryCompanies>>;
  crew_domain_name: string;
  goods_type_id: GoodsTypeId;
  is_possible_oversea_crew: boolean;
  is_studio_worker_admin: boolean;
  products_memberships: MembershipSettingSectionData['memberships'] | null;
  store_url: string;
  stores_product?: StoreProduct;
  is_mobile: boolean;
  profit?: number;
  mpsCategories: MpsCategory[];
}

/* 크리에이터 배송 상품 등록 타입 */
export interface NewCreatorProductData extends CreatorProductDefaultData {
  mode: typeof MODE.NEW;
}

/* 크리에이터 배송 상품 수정 타입 */
export interface EditCreatorProductData extends CreatorProductDefaultData {
  mode: typeof MODE.EDIT;
  sp_cate_list_id: number;
  sp_cate_item_id: number;
  profit: number;
}

/* 마플샵 배송 상품 수정 타입 */
export interface EditCreatorProductData_TPL extends CreatorProductDefaultData {
  mode: typeof MODE.EDIT_TPL;
  sp_cate_list_id: number;
  sp_cate_item_id: number;
  profit: number;
}

/* 마플샵 배송 상품 (해외) 수정 타입 */
export interface EditCreatorProductData_TPL_INTL extends CreatorProductDefaultData {
  mode: typeof MODE.EDIT_TPL_INTL;
  sp_cate_list_id: number;
  sp_cate_item_id: number;
  profit: number;
}

/* 크리에이터 상품 에디터 타입 */
export type CreatorProductData =
  | NewCreatorProductData
  | EditCreatorProductData
  | EditCreatorProductData_TPL
  | EditCreatorProductData_TPL_INTL;
